import { Button, Input, Label } from '@roger/ui-components';
import { ExternalLink } from 'lucide-react';
import TagPicker from './TagPicker';
import type { FaxItemEditor } from './useFaxItemEditor';

interface FaxDetailsFieldsProps {
  editor: FaxItemEditor;
  disabled?: boolean;
  /** The loaded fax is not the one the URL names yet. */
  stale?: boolean;
  onError: (message: string) => void;
}

/** What the fax is called, the way back to the stored original, and its tags. */
export default function FaxDetailsFields({
  editor,
  disabled = false,
  stale = false,
  onError,
}: FaxDetailsFieldsProps) {
  return (
    <div className='space-y-4'>
      <div className='space-y-1.5'>
        <Label htmlFor='fax-name'>Name</Label>
        <div className='flex flex-col gap-2 sm:flex-row sm:items-center'>
          <Input
            id='fax-name'
            aria-label='Name'
            placeholder='What this is'
            value={editor.name}
            onChange={event => editor.setName(event.target.value)}
            disabled={disabled || editor.saving}
          />
          {/* The rail shows a page at a time. This is the whole thing as it
              was stored, without leaving what is half edited. */}
          <Button
            variant='outline'
            type='button'
            className='whitespace-nowrap'
            disabled={!editor.item || stale}
            onClick={() => void editor.openOriginal()}
          >
            <ExternalLink className='mr-2 h-4 w-4' />
            Open original
          </Button>
        </div>
      </div>
      <div className='space-y-1.5'>
        <Label>Tags</Label>
        <TagPicker
          selected={editor.tags}
          onChange={editor.setTags}
          disabled={disabled || editor.saving}
          onError={onError}
        />
      </div>
    </div>
  );
}
